import React from "react";
import { Link } from "react-router-dom";

// Footer — minimal, dark, low-visual-weight. Lives at the bottom of public pages.
// Links to legal + contact pages and surfaces the company entity for trust.
//
// Layout notes:
//   • `pb-12` reserves vertical space below the content so the floating
//     Emergent referral badge (fixed bottom-right, ~32×32 + 16px margins)
//     never overlaps our footer links on iOS Capacitor / narrow phones.
//   • The "Made by humans, not AI" tagline is forced onto its own line via
//     `block` + `mt-1` so it never wraps awkwardly mid-sentence at narrow
//     widths (was hugging the company name + middot on iPhone SE).
//   • `flex-wrap` on the nav lets the 5 link pills overflow gracefully
//     to a second line on screens narrower than ~360px.
const Footer = () => (
  <footer className="relative z-10 mt-12 border-t border-gray-900 bg-black/80 backdrop-blur-sm pb-12 sm:pb-6" data-testid="site-footer">
    <div className="container mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="text-gray-500 text-xs text-center sm:text-left leading-relaxed">
        © {new Date().getFullYear()} <span className="text-gray-300 font-semibold">NETBINGE, LLC</span> · GlobalEyes.TV
        <span className="block text-gray-600 mt-1">Made by humans, not AI.</span>
      </p>
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs">
        <Link to="/privacy" className="text-gray-400 hover:text-emerald-400 transition-colors" data-testid="footer-privacy-link">
          Privacy
        </Link>
        <Link to="/security?src=footer" className="text-gray-400 hover:text-emerald-400 transition-colors" data-testid="footer-security-link">
          Security
        </Link>
        <Link to="/terms" className="text-gray-400 hover:text-emerald-400 transition-colors" data-testid="footer-terms-link">
          Terms
        </Link>
        <Link to="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors" data-testid="footer-contact-link">
          Contact
        </Link>
        <a
          href="https://x.com/GlobalEyesDOTtv"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white transition-colors inline-flex items-center gap-1"
          data-testid="footer-x-handle-link"
          title="Follow @GlobalEyesDOTtv on X — Producers earn monthly credits for following our lists"
        >
          <svg viewBox="0 0 24 24" className="h-3 w-3 fill-current" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
          @GlobalEyesDOTtv
        </a>
      </nav>
    </div>
  </footer>
);

export default Footer;
